module.exports = __webpack_public_path__ + "static/media/9-min.3c82d95c.png";